<template>
    <div class="row">

        <div style="width:380px">

            <!-- 公共参数 -->
            <fieldset>
                <legend>公共参数</legend>

                <div class="param-row">
                    <label>端口号 (#17):</label>
                    <NumberInput v-model="port" style="width:80px" />
                    <span class="hint">跳变信号输入端口</span>
                </div>

                <div class="param-row">
                    <label>有效电平 (#18):</label>
                    <select v-model.number="activeLevel">
                        <option :value="0">0 - 低电平有效</option>
                        <option :value="1">1 - 高电平有效</option>
                    </select>
                </div>

                <div class="param-row">
                    <label>扫描方式 (#19):</label>
                    <NumberInput v-model="scanMode" style="width:80px" />
                </div>

                <div class="param-row">
                    <label>停止模式 (#20):</label>
                    <NumberInput v-model="stopMode" style="width:80px" />
                </div>

                <div class="param-row">
                    <label>探测行程 (#1/#21):</label>
                    <NumberInput v-model="travel" style="width:80px" />
                    <span class="hint">mm</span>
                </div>

                <div class="param-row">
                    <label>粗寻速度 (#16/#22):</label>
                    <NumberInput v-model="fastSpeed" style="width:80px" />
                    <span class="hint">mm/min</span>
                </div>

                <div class="param-row">
                    <label>精寻速度 (#23):</label>
                    <NumberInput v-model="slowSpeed" style="width:80px" />
                    <span class="hint">mm/min</span>
                </div>

                <div class="param-row">
                    <label>回退距离:</label>
                    <NumberInput v-model="retract" style="width:80px" />
                    <span class="hint">mm</span>
                </div>

                <div class="param-row">
                    <label>返回速度:</label>
                    <NumberInput v-model="returnFeed" style="width:80px" />
                    <span class="hint">mm/min</span>
                </div>
            </fieldset>

            <!-- 单边寻边 -->
            <fieldset>
                <legend>单边寻边</legend>

                <div class="param-row">
                    <label>寻边方向:</label>
                    <select v-model="edgeDirection">
                        <option value="X-">X← (X负方向)</option>
                        <option value="X+">X→ (X正方向)</option>
                        <option value="Y+">Y↑ (Y正方向)</option>
                        <option value="Y-">Y↓ (Y负方向)</option>
                        <option value="Z-">Z↓ (Z负方向)</option>
                    </select>
                </div>

                <button @click="generateSingleEdge">生成单边寻边 NC</button>
            </fieldset>

            <!-- 找内圆中心 -->
            <fieldset>
                <legend>找内圆中心</legend>
                <p class="desc">四点寻边测量内圆孔中心：X负、X正、Y负、Y正 四个方向分别探测，自动计算圆心坐标并移动到位。</p>
                <button @click="generateCircleCenter">生成找圆心 NC</button>
            </fieldset>

        </div>

        <!-- 右侧说明区 -->
        <div class="grow" style="margin-left:20px;">
            <div class="help-box">
                <h3>使用说明</h3>
                <ul>
                    <li>寻边器需连接至对应端口（默认端口20）</li>
                    <li>G31 为跳变信号探测指令，碰到工件后自动停止并记录坐标</li>
                    <li>两遍寻边：第一遍快速粗定位，回退后第二遍慢速精确定位</li>
                    <li>生成的 NC 代码将显示在右侧文件面板中</li>
                </ul>

                <h4>单边寻边</h4>
                <p>在指定轴方向上进行两遍探测，用于找到工件边缘的精确位置。</p>
                <p>探测方向符号说明：箭头指向寻边器移动方向，例如 X← 表示向 X 负方向移动探测。</p>

                <h4>找内圆中心</h4>
                <p>在 X/Y 四个方向分别探测内圆孔壁，通过机械坐标系统变量 #880 (X) / #881 (Y) 读取各方向触发位置，计算出圆心坐标后用 G91 增量方式移动到位。</p>
                <p>全程使用 G91 增量移动，避免 G90 绝对定位导致的跑飞问题。适用于圆孔、圆弧槽等特征的中心定位。</p>

                <h4>参数说明</h4>
                <ul>
                    <li><b>端口号</b>：寻边器信号接入的 CNC 输入端口号</li>
                    <li><b>有效电平</b>：触发信号的有效电平，0=低电平，1=高电平</li>
                    <li><b>探测行程</b>：寻边器单次探测的最大移动距离</li>
                    <li><b>粗寻速度</b>：第一遍快速探测的进给速度</li>
                    <li><b>精寻速度</b>：第二遍慢速探测的进给速度，速度越低精度越高</li>
                    <li><b>回退距离</b>：第一遍探测碰到后回退的距离</li>
                </ul>
            </div>
        </div>

    </div>
</template>

<style>
.param-row {
    display: flex;
    align-items: center;
    margin: 4px 0;
    gap: 6px;
}
.param-row label {
    width: 130px;
    text-align: right;
    font-size: 13px;
}
.hint {
    font-size: 12px;
    color: #888;
}
fieldset {
    margin-bottom: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 8px 12px;
}
fieldset legend {
    font-weight: bold;
    color: #555;
}
.desc {
    font-size: 12px;
    color: #666;
    margin: 4px 0 8px 0;
}
.help-box {
    font-size: 13px;
    color: #555;
    line-height: 1.6;
}
.help-box h3 {
    margin-top: 0;
}
.help-box h4 {
    margin-bottom: 4px;
    color: #444;
}
.help-box ul {
    padding-left: 20px;
}
.help-box p {
    margin: 4px 0;
}
</style>

<script>
import { ref, inject } from "vue";
import NumberInput from "./NumberInput.vue";

// Direction definitions
// label 用于生成的文件名和文件内注释（机床端不支持箭头字符，改用前/后/左/右）
const DIRECTIONS = {
    "X-": { axis: "X", sign: "-", retractSign: "+", label: "寻边 X左" },
    "X+": { axis: "X", sign: "+", retractSign: "-", label: "寻边 X右" },
    "Y+": { axis: "Y", sign: "+", retractSign: "-", label: "寻边 Y前" },
    "Y-": { axis: "Y", sign: "-", retractSign: "+", label: "寻边 Y后" },
    "Z-": { axis: "Z", sign: "-", retractSign: "+", label: "寻边 Z下" },
};

const DIRECTION_DESC = {
    "X-": "X负方向寻边，向左探测",
    "X+": "X正方向寻边，向右探测",
    "Y+": "Y正方向寻边，向前探测",
    "Y-": "Y负方向寻边，向后探测",
    "Z-": "Z负方向寻边，向下探测",
};

export default {
    components: { NumberInput },
    setup() {
        const fileManager = inject("fileManager");

        // Common parameters (defaults from reference files)
        const port = ref(20);
        const activeLevel = ref(0);
        const scanMode = ref(0);
        const stopMode = ref(0);
        const travel = ref(100);
        const fastSpeed = ref(50);
        const slowSpeed = ref(10);
        const retract = ref(0.5);
        const returnFeed = ref(1000);

        // Single edge direction
        const edgeDirection = ref("X-");

        function generateCommonHeader() {
            const lines = [];
            lines.push(`#17=${port.value}                     ; 跳变输入端口号${port.value}`);
            lines.push(`#18=${activeLevel.value}                      ; ${activeLevel.value === 0 ? "低电平有效" : "高电平有效"}`);
            lines.push(`#19=${scanMode.value}                      ; 扫描方式`);
            lines.push(`#20=${stopMode.value}                      ; 停止模式`);
            return lines;
        }

        // 当前时间戳，格式：YYYY-MM-DD HH:MM:SS
        function timestamp() {
            const d = new Date();
            const pad = (n) => String(n).padStart(2, "0");
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        }

        function generateSingleEdge() {
            const dir = DIRECTIONS[edgeDirection.value];
            const desc = DIRECTION_DESC[edgeDirection.value];
            const axis = dir.axis;

            // Signed travel: e.g. -#1 or #1
            const signedTravel = dir.sign === "-" ? `-#1` : `#1`;
            // Retract amount: e.g. 0.5 or -0.5
            const retractVal = dir.retractSign === "+"
                ? `${retract.value}`
                : `-${retract.value}`;

            const lines = [];
            lines.push(`; ${dir.label} ${travel.value}mm`);
            lines.push(`; 生成时间：${timestamp()}`);
            lines.push(`; ${desc}`);
            lines.push(`; 第一遍：${fastSpeed.value}mm/min 粗寻边，回退${retract.value}mm`);
            lines.push(`; 第二遍：${slowSpeed.value}mm/min 精寻边`);
            lines.push(`; 寻边器信号跳变输入端口${port.value}，${activeLevel.value === 0 ? "低电平有效" : "高电平有效"}`);
            lines.push("");

            // Common parameters
            lines.push(...generateCommonHeader());
            lines.push("");

            // First pass (fast)
            lines.push(`; 第一遍寻边（快速）`);
            lines.push(`#1=${travel.value}                     ; ${axis}方向探测行程(mm)`);
            lines.push(`#16=${fastSpeed.value}                     ; 探测速度${fastSpeed.value}mm/min`);
            lines.push(`G91 G31 ${axis}${signedTravel} F#16 P#17 L#18 K#19 Q#20`);
            lines.push(`G91 G00 ${axis}${retractVal} F${returnFeed.value}          ; 回退${retract.value}mm`);
            lines.push("");

            // Second pass (slow)
            lines.push(`; 第二遍寻边（慢速）`);
            lines.push(`#1=${travel.value}                     ; ${axis}方向探测行程(mm)`);
            lines.push(`#16=${slowSpeed.value}                     ; 探测速度${slowSpeed.value}mm/min`);
            lines.push(`G91 G31 ${axis}${signedTravel} F#16 P#17 L#18 K#19 Q#20`);
            lines.push("");
            lines.push("M30");

            const ncContent = lines.join("\r\n");
            const filename = `${dir.label}.nc`;
            fileManager.addFileTab(filename, ncContent);
        }

        function generateCircleCenter() {
            const lines = [];
            lines.push("; 找内圆中心");
            lines.push(`; 生成时间：${timestamp()}`);
            lines.push("; 四点寻边测量圆孔中心，移动到圆心位置");
            lines.push(`; 第一次：${fastSpeed.value}mm/min 粗寻边，回退${retract.value}mm`);
            lines.push(`; 第二次：${slowSpeed.value}mm/min 精寻边`);
            lines.push(`; 非寻边移动速度：${returnFeed.value}mm/min`);
            lines.push(`; 寻边器信号接入输入端口${port.value}，${activeLevel.value === 0 ? "低电平有效" : "高电平有效"}`);
            lines.push("; 全程使用G91，避免G90跑飞");
            lines.push("");

            // Parameters
            lines.push(...generateCommonHeader());
            lines.push(`#21=${travel.value}                    ; 探测行程(mm)`);
            lines.push(`#22=${fastSpeed.value}                     ; 粗寻边速度(mm/min)`);
            lines.push(`#23=${slowSpeed.value}                     ; 精寻边速度(mm/min)`);
            lines.push(`#24=${returnFeed.value}                    ; 非寻边移动速度(mm/min)`);
            lines.push("");

            // Record initial position (机械坐标)
            lines.push("; ========== 记录起始位置 ==========");
            lines.push("#100 = #880                 ; 起始点X机械坐标");
            lines.push("#101 = #881                 ; 起始点Y机械坐标");
            lines.push("");

            // X- direction probe
            lines.push("; ========== X负方向寻边 ==========");
            lines.push("G91 G31 X[-#21] F#22 P#17 L#18 K#19 Q#20");
            lines.push(`G91 G00 X${retract.value} F#24`);
            lines.push("G91 G31 X[-#21] F#23 P#17 L#18 K#19 Q#20");
            lines.push("#102 = #880                 ; X负方向触点坐标");
            lines.push("");
            lines.push("; 移动到X正方向起点（起始点）");
            lines.push("G91 G00 X[#100 - #880] F#24");
            lines.push("");

            // X+ direction probe
            lines.push("; ========== X正方向寻边 ==========");
            lines.push("G91 G31 X[#21] F#22 P#17 L#18 K#19 Q#20");
            lines.push(`G91 G00 X-${retract.value} F#24`);
            lines.push("G91 G31 X[#21] F#23 P#17 L#18 K#19 Q#20");
            lines.push("#103 = #880                 ; X正方向触点坐标");
            lines.push("");

            // Calculate X center and move incrementally to center
            lines.push("; ========== 计算X中心并移动到X中心位置 ==========");
            lines.push("#110 = [#102 + #103] / 2     ; X轴中心机械坐标");
            lines.push("");
            lines.push("; 当前在X正触点位置（#103）");
            lines.push("; 需要移动到X中心（#110）");
            lines.push("; 移动距离 = X中心 - X正触点");
            lines.push("#120 = #110 - #103");
            lines.push("G91 G00 X#120 F#24");
            lines.push("");

            // Y- direction probe
            lines.push("; ========== Y负方向寻边 ==========");
            lines.push("; 注意：此时X已在中心位置，Y还在起始点位置（#101）");
            lines.push("G91 G31 Y[-#21] F#22 P#17 L#18 K#19 Q#20");
            lines.push(`G91 G00 Y${retract.value} F#24`);
            lines.push("G91 G31 Y[-#21] F#23 P#17 L#18 K#19 Q#20");
            lines.push("#104 = #881                 ; Y负方向触点坐标");
            lines.push("");
            lines.push("; 移动到Y正方向起点（起始点）");
            lines.push("G91 G00 Y[#101 - #881] F#24");
            lines.push("");

            // Y+ direction probe
            lines.push("; ========== Y正方向寻边 ==========");
            lines.push("G91 G31 Y[#21] F#22 P#17 L#18 K#19 Q#20");
            lines.push(`G91 G00 Y-${retract.value} F#24`);
            lines.push("G91 G31 Y[#21] F#23 P#17 L#18 K#19 Q#20");
            lines.push("#105 = #881                 ; Y正方向触点坐标");
            lines.push("");

            // Calculate Y center and move incrementally to center
            lines.push("; ========== 计算Y中心并移动到Y中心位置 ==========");
            lines.push("#111 = [#104 + #105] / 2     ; Y轴中心机械坐标");
            lines.push("");
            lines.push("; 当前在Y正触点位置（#105）");
            lines.push("; 需要移动到Y中心（#111）");
            lines.push("; 移动距离 = Y中心 - Y正触点");
            lines.push("#121 = #111 - #105");
            lines.push("G91 G00 Y#121 F#24");
            lines.push("");
            lines.push("; 此时机床位置即为圆心（X和Y都已到位）");
            lines.push("");
            lines.push("M30");

            const ncContent = lines.join("\r\n");
            fileManager.addFileTab("找内圆中心.nc", ncContent);
        }

        return {
            port, activeLevel, scanMode, stopMode,
            travel, fastSpeed, slowSpeed, retract, returnFeed,
            edgeDirection,
            generateSingleEdge,
            generateCircleCenter,
        };
    },
};
</script>
